const status = [
  {
    path: '/attendance/status/month',
    component: () => import('@/page/attendance/status/Month.vue'),
    meta: {
      name: '월별',
      isActive: false,
      isBread: false,
    },
  },
  {
    path: '/attendance/status/day',
    component: () => import('@/page/attendance/status/Day.vue'),
    meta: {
      name: '일별',
      isActive: false,
      isBread: false,
    },
  },
  {
    path: '/attendance/status/year',
    component: () => import('@/page/attendance/status/Year.vue'),
    meta: {
      name: '연도별',
      isActive: false,
      isBread: false,
    },
  },
];

export default status;
